import React from 'react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-dark text-cream/90 py-3 px-4 border-b border-gold/20" data-id="element-342">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-4 text-xs md:text-sm tracking-[0.25em] uppercase font-semibold" data-id="element-343">
        <span className="w-6 h-px bg-gold/50 hidden md:block" data-id="element-344" />
        <span className="text-gold" data-id="element-345">Oferta Exclusiva de Lanzamiento</span>
        <svg className="w-1.5 h-1.5 text-gold/60 flex-shrink-0" viewBox="0 0 6 6" fill="currentColor" data-id="element-346">
          <rect x="0.88" y="0.88" width="4.24" height="4.24" transform="rotate(45 3 3)" data-id="element-347" />
        </svg>
        <span data-id="element-348">Precio Especial por Tiempo Limitado</span>
        <span className="w-6 h-px bg-gold/50 hidden md:block" data-id="element-349" />
      </div>
    </div>;
}